module.exports = __webpack_public_path__ + "676246527fe04242f0f722440e577866.svg";